const ASSETS = "/images/crowdfunding/";

// Editorial imagery is reserved for explicitly fictional, non-live campaigns.
export function fictionalCampaignPresentation(campaign) {
  const title = campaign?.current_version?.title || campaign?.project?.title || "";
  if (campaign?.environment === "live" || !/^\[démo\]/i.test(title)) return null;
  const subjects = [
    [/jardin|verger|ruches|grainothèque|serre/i, "garden", "Cultiver ensemble, faire grandir le quartier et renouer avec la nature."],
    [/vélo/i, "bicycle", "Un atelier pour réparer, transmettre les bons gestes et remettre les vélos en mouvement."],
    [/cuisine/i, "kitchen", "Une cuisine ouverte sur le quartier, pour préparer et partager des repas qui rassemblent."],
    [/musical|festival|cinéma|fresque/i, "music", "Un lieu de rencontre pour faire vivre la création et rendre la culture accessible."],
    [/couture|bois|mobilier/i, "craft", "Des outils et des savoir-faire à partager pour fabriquer, réparer et donner une seconde vie."],
    [/sportif|randonnée/i, "outdoors", "Rendre les activités de plein air accessibles et partager le plaisir de bouger ensemble."],
  ];
  const [, image, summary] = subjects.find(([pattern]) => pattern.test(title))
    || [null, "library", "Un espace de proximité pour lire, apprendre et partager entre générations."];
  return { image: `${ASSETS}${image}.webp`, summary };
}

export function crowdfundingDonationType(project) {
  return project?.fundingModel === "reward" ? "reward" : "donation";
}

export function campaignDisplayTitle(project) {
  return project?.fictionalIllustration ? project.title.replace(/^\[démo\]\s*/i, "") : project.title;
}
